'use strict';

angular.module('app.exposureReportPlatform', [])
    .directive('exposureReportPlatformDirective', function () {
        return {
            controller: 'exposureReportPlatformCtrl',
            templateUrl: 'app/measure/exposureReport/exposureReportPlatform/exposureReportPlatform.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })